import React, { useState, memo } from 'react';
import { XIcon, ShoppingBagIcon } from 'lucide-react';
interface AddToBagModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (name: string) => void;
  productName: string;
}
export function AddToBagModal({
  isOpen,
  onClose,
  onConfirm,
  productName
}: AddToBagModalProps) {
  const [designName, setDesignName] = useState('');
  if (!isOpen) return null;
  const handleConfirm = () => {
    if (designName.trim()) {
      onConfirm(designName.trim());
      setDesignName('');
    }
  };
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && designName.trim()) {
      handleConfirm();
    }
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-33">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full" data-id="element-34">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-35">
          <div className="flex items-center gap-3" data-id="element-36">
            <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-37">
              <ShoppingBagIcon className="w-5 h-5 text-blue-600" data-id="element-38" />
            </div>
            <div data-id="element-39">
              <h3 className="text-lg font-semibold text-gray-900" data-id="element-40">
                Add to Shopping Bag
              </h3>
              <p className="text-sm text-gray-500" data-id="element-41">{productName}</p>
            </div>
          </div>
          <button onClick={onClose} className="p-1 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-42">
            <XIcon className="w-5 h-5" data-id="element-43" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4" data-id="element-44">
          <div data-id="element-45">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-46">
              Design Name <span className="text-red-500" data-id="element-47">*</span>
            </label>
            <input type="text" value={designName} onChange={e => setDesignName(e.target.value)} onKeyPress={handleKeyPress} placeholder="e.g., Summer Collection Logo" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" autoFocus data-id="element-48" />
            <p className="text-xs text-gray-500 mt-1" data-id="element-49">
              Give your design a memorable name for easy reference
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="flex gap-3 p-6 border-t border-gray-200" data-id="element-50">
          <button onClick={onClose} className="flex-1 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm font-medium rounded-lg transition-colors" data-id="element-51">
            Cancel
          </button>
          <button onClick={handleConfirm} disabled={!designName.trim()} className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white text-sm font-medium rounded-lg transition-colors" data-id="element-52">
            Add to Bag
          </button>
        </div>
      </div>
    </div>;
}